import React from 'react'
import FlexContainer from 'core-system/FlexContainer'
import Text from 'core-system/Text'
import palette from 'core-system/Themes/palette'
import moment, { Moment } from 'moment'
import NumberInput from 'core-system/Input/NumberInput/NumberInput'
import NumberFormatter from 'core-system/Input/NumberInput/NumberFormatter'
import styled from 'styled-components'
import DateUtils from 'shared/DateUtils'

interface FinalizeAllocationsDateProps {
  setupMode: 'manual' | 'hris'
  canEdit: boolean
  onContributionDayChange: (newDay: number) => void
  contributionDays: number
  contribStartDate: Moment
}

const StaticContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 1rem;
  background-color: ${(props) => props.theme.palette.secondary.purple200};
  border: 1px solid ${(props) => props.theme.palette.grey.grey300};
  border-radius: 0.5rem;
  max-width: ${(props) => props.theme.pxToRem(460)};
`

const FinalizeAllocationsDate = ({
  setupMode,
  canEdit,
  onContributionDayChange,
  contributionDays,
  contribStartDate,
}: FinalizeAllocationsDateProps) => {
  const getCurrentMonthDeadlineDay = (contribDay: number) => {
    return moment(`${moment().format('YYYY-MM')}-${contribDay}`, 'YYYY-MM-DD')
  }
  return (
    <>
      {setupMode === 'manual' ? (
        <FlexContainer flexDirection='column' marginBottom='1rem'>
          <Text variant='h5' marginBottom='1rem'>
            By what date should your employees finalize their allocations for
            the following month?
          </Text>
          <Text
            variant='body1'
            marginBottom='0.5rem'
            color={palette.text.secondary}
          >
            You can use this to set the latest date employees can declare
            allocation. The latest date that we allow is the 27th of the month.
          </Text>
        </FlexContainer>
      ) : (
        <Text variant='h4' marginBottom='1rem'>
          The latest date your employees can finalize their allocations for the
          following month:
        </Text>
      )}
      {canEdit && setupMode === 'manual' ? (
        <>
          <NumberInput
            padding='1rem'
            onValueChange={onContributionDayChange}
            value={contributionDays}
            iconSize={20}
            incrementVal={1}
            maxHeight='2.5rem'
          >
            <NumberFormatter
              currencyFormat='days'
              decimalScale={0}
              fontVariant='h5'
            />
          </NumberInput>
          {moment().isAfter(
            moment(
              `${contribStartDate.format('YYYY-MM')}-${contributionDays}`,
              'YYYY-MM-DD'
            )
          ) ? (
            <Text
              variant='body2'
              marginTop='0.5rem'
              textColor={palette.error.red500}
            >
              {`Please note that since this allocation deadline is on or before the current date, you must set the spend start date to ${getCurrentMonthDeadlineDay(
                contributionDays
              )
                .add(2, 'months')
                .format('MMMM')} at the earliest.`}
            </Text>
          ) : null}
        </>
      ) : (
        <StaticContainer>
          <Text variant='action4'>
            {DateUtils.getDayOfTheMonth(contributionDays)} of every month
          </Text>
        </StaticContainer>
      )}
    </>
  )
}

export default React.memo(FinalizeAllocationsDate)
